import React from 'react';

import {Checkbox, Radio, Text} from '@gravity-ui/uikit';
import {QuestionType, WidgetType} from 'common/constants/survey';

import {cnAnswerOption} from './AnswerOption.constants';

export const getContent = (
    text: string,
    type: QuestionType,
    widget?: WidgetType,
    selected?: boolean,
) => {
    const stringContent = (
        <Text variant="body-2" className={cnAnswerOption('Text')} as="div">
            {text}
        </Text>
    );

    const checkboxContent = (
        <Checkbox
            checked={selected}
            size="l"
            className={cnAnswerOption('Control')}
            content={stringContent}
            controlProps={{'aria-hidden': true}}
        />
    );

    const radioContent = (
        <Radio
            value=""
            checked={selected}
            size="l"
            className={cnAnswerOption('Control')}
            content={stringContent}
            controlProps={{'aria-hidden': true}}
        />
    );

    switch (type) {
        case QuestionType.Enum: {
            switch (widget) {
                case WidgetType.Checkbox:
                    return checkboxContent;
                default:
                    return radioContent;
            }
        }
        case QuestionType.Checkbox:
            return checkboxContent;
        case QuestionType.Radio:
        case QuestionType.OneRow:
        case QuestionType.Stars:
            return radioContent;
        case QuestionType.String:
            return stringContent;
    }
    return null;
};
